import request from '@/utils/axios'
import qs from 'qs'

/**
 * 根据班级类型id获取班级类型与课程时间
 * @param {*} params 
 * @returns 
 */
export function getclasstypeandtimebyclasstypeid(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/classtypeandtime/getclasstypeandtimebyclasstypeid',
        method: 'post',
        data: postData
    })
}

/**
 * 获取班级类型与课程时间
 * @param {*} params 
 * @returns 
 */
export function getclasstypeandtime(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/classtypeandtime/getclasstypeandtime',
        method: 'post',
        data: postData
    })
}

/**
 * 添加班级类型与课程时间
 * @param {*} params 
 * @returns 
 */
export function addclasstypeandtime(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/classtypeandtime/addclasstypeandtime',
        method: 'post',
        data: postData
    })
}

/**
 * 修改班级类型与课程时间
 * @param {*} params 
 * @returns 
 */
export function editclasstypeandtime(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/classtypeandtime/editclasstypeandtime',
        method: 'post',
        data: postData
    })
}

/**
 * 删除班级类型与课程时间
 * @param {*} params 
 * @returns 
 */
export function deleteclasstypeandtime(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/classtypeandtime/deleteclasstypeandtime',
        method: 'post',
        data: postData
    })
}